import { identifyError, identifyRequest, identifySuccess } from './get-token';
import { assignCurrentCart } from '../cart';
import { loadUser } from '../user';
export const handleCallback = () => {
  return async (dispatch, _getState, _ref) => {
    let {
      auth
    } = _ref;
    try {
      dispatch(identifyRequest());
      const token = await auth.handleCallback();
      dispatch(identifySuccess(token));
    } catch (error) {
      dispatch(identifyError(error));
      throw error;
    }
    // see the note in actions/initialize/index.ts about this specific feature
    // flag.
    if (typeof auth.currentUrlHandlesCallback === 'function') {
      await Promise.allSettled([
      // If the user has a current cart, associate it with the logged in user
      dispatch(assignCurrentCart()),
      // Load the user as well
      dispatch(loadUser())]);
    }
  };
};